import React, { useState } from "react";
import AsyncLoading from "../AsyncLoading/AsyncLoading";
import AsyncSelect from "react-select/async";
import { useContentSearchLoader } from "../../hooks/useContentSearchLoader";
import { ASSOCIABLE_PROJECT_TYPES } from "../../shared/constants/contentType";
import Option from "../AssociateFieldset/Option/Option";

const AssociatedProject = (props) => {
  const { value, defaultValue, handleChange } = props;

  const [state, setState] = useState({
    projectsIds: [],
    load: [],
    created: [],
  });

  const loadOptions = useContentSearchLoader({
    types: ASSOCIABLE_PROJECT_TYPES,
  });

  const filterAssociated = (items) => {
    const list = [];
    if (!!items) {
      items.forEach((el) => {
        list.push(el.value);
      });
    }
    return list;
  };

  const handleChangeAssociated = (item) => {
    const newState = { ...state };
    newState.researchsIds = item;

    setState(newState);
    if (!!value) {
      handleChange(item);
    } else {
      handleChange(filterAssociated(item));
    }
  };

  return (
    <div className="AssociatedProject">
      <div className="formField">
        <AsyncSelect
          isMulti
          className="reactSelect"
          classNamePrefix="reactSelect"
          loadOptions={loadOptions}
          onChange={handleChangeAssociated}
          components={{
            LoadingIndicator: () => <AsyncLoading />,
            Option,
          }}
          noOptionsMessage={() => "Nenhum item encontrado"}
          loadingMessage={() => "Carregando..."}
          placeholder="Selecione"
          value={value}
          defaultValue={defaultValue}
          openMenuOnClick={false}
        />
      </div>
    </div>
  );
};

export default AssociatedProject;
